import { BlockModule } from '@/website/blocks/common'
import { defineAsyncComponent, defineComponent } from 'vue'

new BlockModule({
    selector: '.block-sonner',
    vueComponent: defineComponent({
        components: {
            Sonner: defineAsyncComponent(() => import('@/components/ui/sonner/Sonner.vue')),
        },
    }),
})
